import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme, Container, Box, Typography } from "@mui/material";

import PageContent from "./PageContent";
import Title from "../../../components/typography/Title";

const UserContainer = ({ children, title, message, checkUid = true }) => {

    const navigate = useNavigate();
    const theme = useTheme();

    const uid = useSelector(state => state.user.uid);

    useEffect(() => {
        if (Boolean(uid) && checkUid) {
            navigate("/");
        }
    }, [uid]);

    return (
        <PageContent showImageHeader={false} paddingTop={6} footerWidth={null}>
            <Container maxWidth="sm">
                <Box sx={{
                    boxShadow: theme.shadows[3],
                    borderRadius: theme.spacing(3),
                    padding: theme.spacing(4),
                }}>
                    <Title label={title} variant="h2" fullWidth={true} />
                    <Typography sx={{ marginTop: theme.spacing(2)}}>
                        {message}
                    </Typography>
                    {children}
                </Box>
            </Container>
        </PageContent>
        
    );
};

export default UserContainer;
